// ============================================================
// Galathiya.js - Dark blue gradient banner for Galathiya project
// ============================================================

import { GALATHIYA_BG } from "../data";

function Galathiya() {
  return (
    <section
      className="galathiya"
      id="galathiya-project"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 31, 100, 0.8), rgba(0, 31, 100, 0.8)), url(${GALATHIYA_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Icon */}
      <div className="galathiya-logo">
        <svg width="76" height="76" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <path d="M3 11 C 7 3.5 17 3.5 21 11" fill="white" />
          <path d="M7 14.5 C 10 18.5 14 18.5 17 14.5" fill="white" />
        </svg>
      </div>
      {/* Text */}
      <h2>Galathiya Bay Project Support</h2>
      <p>
        Complete, end-to-end local support services for the Galathiya Bay /
        Great Nicobar Strategic Infrastructure Project
      </p>

      {/* Button */}
      <a href="#contact" className="btn-outline-white" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
        Learn More About Our Strategic Support
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </section>
  );
}

export default Galathiya;
